import React from 'react'
import './index.less'

export default function HomeMiddle() {
  return (
    <div className="light-home-middle">
      <div className="middle-title">
        产品远销全球
        <span className="space-num">
          78
        </span>
        个国家，跨越
        <span className="space-num">
          156
        </span>
        个城市
      </div>
    </div>
  )
}